// extracted by mini-css-extract-plugin
module.exports = {"dialogContent":"dialogContent-2fuev","header":"header-369Y0"};